import React from 'react';

/**
 * Returns whether a React children value contains content that would render
 * in the DOM.
 *
 * Unlike {@link React.Children.count}, this treats boolean children such as
 * `false` (from patterns like `condition && <Item />`) as empty. Whitespace-only
 * text nodes are also ignored.
 *
 * @param children - The React children value to inspect.
 * @returns `true` when at least one child would render visible content.
 *
 * @example
 * hasRenderableChildren(false); // false
 * hasRenderableChildren(<div />); // true
 * hasRenderableChildren(['\n  ', false]); // false
 */
export const hasRenderableChildren = (children: React.ReactNode): boolean =>
  React.Children.toArray(children).some(
    (child) => typeof child !== 'string' || child.trim().length > 0
  );
